import {createAction} from 'redux-actions'
import * as ActionTypes from "./actionTypes"
import {
    changeCustomerAssignments,
    changeManagementAssignmentsSelection as changeManagementAssignmentsSelectionUserPanel,
    changeProjectAssignments,
    changeTasksAssignments
} from '../../../panels/user/createPanel/actions'
import {getCustomerIds, getProjectIds, getTab, getTaskIds} from './selectors'
import actionsGenerator from '../hierarchyAssignmentsPanelTab/actionsGenerator'
import {getManageAssignments, getManagementAssignmentsCptIds} from '../../../panels/user/createPanel/selectors'
import {HierarchyLevels} from 'constants'
import rpcCall from '../../../util/rpc/rpcCalls'
import {addCustomers, addProjects, addTasks} from '../../../entities/actions'
import {managementAssignmentsCountsLoadSuccess} from '../../../panels/user/userData/actions'
import {setViewerManagementAssignmentsCounters} from '../common/actions'
import {hierarchyAssignmentsEditorActions} from '../createUserManagementAssignmentsEditor/actions'
import {arrayToSet} from '../../../atUtils'
import {getManagementAssignmentsCounters} from '../../../panels/user/userData/selectors'

const hierarchyAssignmentsTabActions = actionsGenerator({
    actionTypes: ActionTypes
})

export const setTaskIds = hierarchyAssignmentsTabActions.setTaskIds

export const setProjectIds = hierarchyAssignmentsTabActions.setProjectIds

export const setCustomerIds = hierarchyAssignmentsTabActions.setCustomerIds

export const setUserId = hierarchyAssignmentsTabActions.setUserId

export const setTab = hierarchyAssignmentsTabActions.setTab

export const setManageTaskIds = hierarchyAssignmentsTabActions.setManageTaskIds

export const setManageProjectIds = hierarchyAssignmentsTabActions.setManageProjectIds

export const setManageExcludingSelfProjectIds = hierarchyAssignmentsTabActions.setManageExcludingSelfProjectIds

export const setManageCustomerIds = hierarchyAssignmentsTabActions.setManageCustomerIds

export const setManageExcludingSelfCustomerIds = hierarchyAssignmentsTabActions.setManageExcludingSelfCustomerIds

export const setUserCounters = hierarchyAssignmentsTabActions.setUserCounters

export const setTaskTabLoaded = hierarchyAssignmentsTabActions.setTaskTabLoaded

export const setProjectTabLoaded = hierarchyAssignmentsTabActions.setProjectTabLoaded

export const setCustomerTabLoaded = hierarchyAssignmentsTabActions.setCustomerTabLoaded

export const setSearchString = hierarchyAssignmentsTabActions.setSearchString

export const setSearchOpen = hierarchyAssignmentsTabActions.setSearchOpen

export const setLoading = hierarchyAssignmentsTabActions.setLoading

export const setLoaded = hierarchyAssignmentsTabActions.setLoaded

export const openPanel = hierarchyAssignmentsTabActions.openPanel

export const setIsShowArchiveEntities = hierarchyAssignmentsTabActions.setIsShowArchiveEntities

export const closePanel = () => dispatch => {
    dispatch(setShown(false))
    dispatch(hierarchyAssignmentsTabActions.closePanel())
}

export const clearTabsLoaded = hierarchyAssignmentsTabActions.clearTabsLoaded

export const setShown = createAction(ActionTypes.SHOWN_SET)

export const setCanManageAllScope = createAction(ActionTypes.ALL_SCOPE_SET)

export const loadData = () => (dispatch, getState) => {
    const userManagementData = getManageAssignments(getState())
    dispatch(setCanManageAllScope(userManagementData.canManageAllScope))

    const assignmentsCptIds = getManagementAssignmentsCptIds(getState())
    const tabType = getTab(getState())
    dispatch(setLoading(true))
    rpcCall('UserManagementService.getViewUserManagementAssignmentsForCreateUser', [assignmentsCptIds, tabType])
        .then((data) => {
            dispatch(prepareLoadedData(data, tabType))
            dispatch(setLoading(false))
        })
        .catch((err) => {
            dispatch(setLoading(false))
            console.log(err)
        })
}

const prepareLoadedData = (data, tabType) => (dispatch) => {
    dispatch(addCustomers(data.customers))
    dispatch(addProjects(data.projects))
    dispatch(addTasks(data.tasks))

    dispatch(managementAssignmentsCountsLoadSuccess(data.userCounter))
    dispatch(setUserCounters(data.userCounter))
    dispatch(setViewerManagementAssignmentsCounters(data.viewerCounter))

    const maCptIds = data.managementAssignmentsCptIds

    dispatch(setManageTaskIds(arrayToSet(maCptIds.taskIds)))
    dispatch(setManageProjectIds(arrayToSet(maCptIds.projectIds)))
    dispatch(setManageExcludingSelfProjectIds(arrayToSet(maCptIds.projectIdsExcludingSelf)))
    dispatch(setManageCustomerIds(arrayToSet(maCptIds.customerIds)))
    dispatch(setManageExcludingSelfCustomerIds(arrayToSet(maCptIds.customerIdsExcludingSelf)))

    switch (tabType) {
        case HierarchyLevels.TASK:
            dispatch(setTaskIds(data.taskIds))
            dispatch(setTaskTabLoaded(true))
            break
        case HierarchyLevels.PROJECT:
            dispatch(setProjectIds(data.projectIds))
            dispatch(setProjectTabLoaded(true))
            break
        case HierarchyLevels.CUSTOMER:
            dispatch(setCustomerIds(data.customerIds))
            dispatch(setCustomerTabLoaded(true))
            break
    }
    dispatch(setLoaded(true))
}

export const changeManagementAssignmentsSelection = (managementAssignmentsSelection) => (dispatch) => {
    dispatch(changeManagementAssignmentsSelectionUserPanel(managementAssignmentsSelection))
    dispatch(loadData())
}

export const changeAssignmentPanelTab = (tab) => (dispatch, getState) => {
    const prevTab = getTab(getState())
    if (prevTab !== tab) {
        dispatch(setSearchString(null))
        dispatch(setTab(tab))
    }
}

export const openManagementAssignmentPanel = (id, tab) => (dispatch, getState) => {
    const counters = getManagementAssignmentsCounters(getState())

    dispatch(setLoaded(counters.customers === 0 && counters.projects === 0 && counters.tasks === 0))
    dispatch(setCustomerTabLoaded(counters.customers === 0))
    dispatch(setProjectTabLoaded(counters.projects === 0))
    dispatch(setTaskTabLoaded(counters.tasks === 0))

    dispatch(setTab(tab))
    dispatch(setSearchString(null))

    dispatch(setShown(true))
}

export const revokeAllTypeAction = () => (dispatch, getState) => {
    const selectedTab = getTab(getState())
    let entityIds = []
    switch (selectedTab) {
        case HierarchyLevels.CUSTOMER:
            entityIds = getCustomerIds(getState())
            dispatch(changeCustomerAssignments({
                removedIds: entityIds
            }))
            dispatch(hierarchyAssignmentsEditorActions.clearAll())
            break
        case HierarchyLevels.PROJECT:
            entityIds = getProjectIds(getState())
            dispatch(changeProjectAssignments({
                removedIds: entityIds
            }))
            dispatch(hierarchyAssignmentsEditorActions.clearAll())
            break
        case HierarchyLevels.TASK:
            entityIds = getTaskIds(getState())
            dispatch(changeTasksAssignments({
                removedIds: entityIds
            }))
            dispatch(hierarchyAssignmentsEditorActions.clearAll())
            break
    }
    // TODO bakharev: get counters for panel
    dispatch(loadData())
}

export const revokeEntitiesAction = (revokeEntityLevel, id) => (dispatch, getState) => {
    const selectedTab = getTab(getState())
    let entityIds = []
    switch (selectedTab) {
        case HierarchyLevels.CUSTOMER:
            entityIds = getCustomerIds(getState())
            dispatch(changeCustomerAssignments({
                removedIds: [id]
            }))
            dispatch(hierarchyAssignmentsEditorActions.clearAll())
            break
        case HierarchyLevels.PROJECT:
            entityIds = getProjectIds(getState())
            dispatch(changeProjectAssignments({
                removedCustomerIds: (revokeEntityLevel === HierarchyLevels.CUSTOMER) ? [id]: [],
                removedIds: (revokeEntityLevel === HierarchyLevels.PROJECT) ? [id]: [],
            }))
            dispatch(hierarchyAssignmentsEditorActions.clearAll())
            break
        case HierarchyLevels.TASK:
            entityIds = getTaskIds(getState())
            dispatch(changeTasksAssignments({
                // TODO bakharev: add removedCustomerIds parameter
                removedProjectIds: (revokeEntityLevel === HierarchyLevels.PROJECT) ? [id]: [],
                removedIds: (revokeEntityLevel === HierarchyLevels.TASK) ? [id]: [],
            }))
            dispatch(hierarchyAssignmentsEditorActions.clearAll())
            break
    }
    // TODO bakharev: get counters for panel
    dispatch(loadData())
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createManagementAssignmentsPanel/actions.js